import React, {
  createContext, useContext, useMemo, useRef,
  useState,
} from 'react';

const SectionsRefContext = createContext();

// eslint-disable-next-line react/prop-types
export function SectionsRefProvider({ children }) {
  const sectionsRef = useRef([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const registerSectionRef = (index, el) => {
    if (el) {
      sectionsRef.current[index] = el;
    }
  };
  const contextValue = useMemo(() => ({
    sectionsRef,
    registerSectionRef,
    currentIndex,
    setCurrentIndex,
  }), [currentIndex]);
  return (
    <SectionsRefContext.Provider value={contextValue}>
      {children}
    </SectionsRefContext.Provider>
  );
}

export const useSectionsRef = () => useContext(SectionsRefContext);
